"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consultOutcomes = void 0;
var consultOutcomes;
(function (consultOutcomes) {
    consultOutcomes["APPROVED"] = "approved";
    consultOutcomes["DENIED"] = "denied";
    consultOutcomes["OPT_OUT"] = "opt-out";
    consultOutcomes["UNREACHABLE"] = "unreachable";
    consultOutcomes["AUTO_RESOLVED"] = "auto-resolved";
    consultOutcomes["RESOLVED"] = "resolved";
})(consultOutcomes || (exports.consultOutcomes = consultOutcomes = {}));
